export default {
  notifications: [],
  notificationsPagination: {},
  unreadNotifications: null,
};
